import React from 'react';
import {Text, View, StyleSheet } from '@react-pdf/renderer';

const styles = StyleSheet.create({
    headerContainer: {
        marginTop: 36
    },
    billTo: {
        marginTop: 20,
        paddingBottom: 3,
        fontFamily: 'Helvetica-Oblique'
    },
  });

  const CompanyInfo = ({directors}) => (
    <View style={styles.headerContainer}>
        <Text>Company Name: {directors.company}</Text>
        <Text>Address: {directors.address}</Text>
    </View>
  );
  
  export default CompanyInfo